import { useCallback, useRef } from "react";
import { TopHeadValidateUrl } from "../constants";

const useScanImages = () => {
  const imagesRef = useRef({});

  const addImage = (faceSide, imageData) => {
    imagesRef.current = { ...imagesRef.current, [faceSide]: imageData };
    // setImages((prevImage) => [...prevImage, { faceSide, imageData }]);
  };

  const uploadImages = async (apiUrl, apiToken) => {
    try {
      for (const [faceSide, imageData] of Object.entries(imagesRef.current)) {
        const imageContent = imageData
          .toString()
          .replace(/^data:image\/jpeg;base64,/, "");
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: apiToken,
          },
          body: JSON.stringify({
            image: imageContent,
            faceSide: faceSide,
          }),
        });
        if (!response.ok) {
          throw new Error("Failed to upload image");
        }
      }
      imagesRef.current = {};
      return true;
    } catch (error) {
      return false;
    }
  };

  const validateTopHeadImage = useCallback(async () => {
    // In case topHead is not detected it should raise an error
    if (imagesRef.current.top === undefined)
      return { ok: false, isHeadDetected: false };

    try {
      const imageContent = imagesRef.current.top
        .toString()
        .replace(/^data:image\/jpeg;base64,/, "");
      const response = await fetch(TopHeadValidateUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          imageBase64: imageContent,
        }).toString(),
      });
      if (!response.ok) {
        throw new Error("Failed to validate top head image");
      }
      const responseData = await response.json();
      return { ok: true, isHeadDetected: responseData?.headDetected ?? false };
    } catch (error) {
      return { ok: false, isHeadDetected: false };
    }
  }, []);

  const imagesCaptured = Object.keys(imagesRef.current).length > 0;

  return { imagesCaptured, addImage, uploadImages, validateTopHeadImage };
};

export default useScanImages;
